import { RatingService } from "@/orders/services/rating/rating.types";
import { BACKEND_ORDERS_WRITES_BASE_URL } from "@/services";
import { Vue } from "vue-property-decorator";

export class RatingServiceImpl implements RatingService {
  async sendRating(request: any): Promise<void> {
    await Vue.$axios.post<void>(`${BACKEND_ORDERS_WRITES_BASE_URL}/api/v1/ratings/send`, request);
  }
}
